import React from 'react';
import { withStyles } from '@mui/styles';

const styles = {
  selectableItem: {
    margin: '1px 2px',
    cursor: 'pointer',
    padding: '0px 5px',
    width: 'fit-content',
    borderRadius: '10px',
    //border: '1px solid #4c4c4c',
    '&:hover': {
      backgroundColor: '#ffff',//'#eeecf8',
    },
  }
};

const TreeView = ({ data, classes, pasteValToJson }) => {
  const renderNode = (node, prefix) => {
    return Object.keys(node).map(key => {
      const value = node[key];
      const fullPath = `${prefix}/${key}`;
      if (typeof value === 'object' && value !== null) {
        return (
          <div style={{ borderLeft: Number.isInteger(+key) ? '1px solid #4c4c4c' : '' }} key={fullPath}>
            {Number.isInteger(+key) ?
              <div style={{ borderTop: '1px solid #4c4c4c', width: '30px' }}></div> :
              <strong style={{ marginLeft: '8px' }}>{key}</strong>
            }

            <div style={{ marginLeft: Number.isInteger(+key) ? '' : '10px', padding: '1px 0' }}>
              {renderNode(value, fullPath)}
            </div>
          </div>
        );
      } else {
        return (//{value} is key
          <div
            className={classes.selectableItem}
            onClick={() => {
              pasteValToJson(fullPath);

            }}
            key={fullPath}
          >
            <span>&#8901;{key}</span>
          </div>
        );
      }
    });
  };

  return (
    <div>
      {renderNode(data, '')}
    </div>
  );
};

export default withStyles(styles)(TreeView);
